import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import type { AddNoteSchemaType } from '@src/notes/AddNoteSchema';
import type { NoteParentType } from '@src/notes/domain/Note';
import { NoteContentField, NoteContextField } from '@src/notes/NoteFields';

export const NoteAssembler = {
  fromForm: (
    userId: string,
    parent: {
      id: string;
      type: NoteParentType;
    },
    data: AddNoteSchemaType,
  ): AddNoteRequest => {
    return {
      author: userId,
      tags: data[NoteContextField.fieldName],
      content: data[NoteContentField.fieldName],
      parent,
    };
  },
};
